import { render } from "./ListFonction.vue?vue&type=template&id=5b8ddf6a&ts=true"
import script from "./ListFonction.vue?vue&type=script&lang=ts"
export * from "./ListFonction.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__